import React from 'react';
import PropTypes from 'prop-types';
import {roles} from "../../utils/auth";
import styled from "@emotion/styled";

const ContentWrapper = styled.span`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
`;

const SmsRoleTag = styled.div`
    width: 55px;
    height: 30px;
    
    /* default/gray/700 */
    background: #4E5664;
    border-radius: 4px;
    
    color: #B7E140;
`;

const DigicelRoleTag = styled.div`
    width: 69px;
    height: 30px;
    
    /* default/red/700 */
    background: var(--color-red-700);
    border-radius: 4px;
    
    color: var(--color-white);
`;

const GraceRoleTag = styled.div`
    width: 127px;
    height: 30px;
    
    /* default/red/800 */
    background: var(--color-red-800);
    border-radius: 4px;
    
    justify-content: center;
    align-items: center;
    
    color: var(--color-white)
`;

const TextWrapper = styled.div`
   margin: auto;
   width: fit-content;
   line-height: 28px;
`;

const CustomerRoleTag = styled.div``;


function UserRole({role}) {

    const sms = <SmsRoleTag> <TextWrapper> SMS </TextWrapper>  </SmsRoleTag>;
    const digicel = <DigicelRoleTag> <TextWrapper> Digicel </TextWrapper> </DigicelRoleTag>;
    const grace = <GraceRoleTag> <TextWrapper> Grace Kennedy </TextWrapper> </GraceRoleTag>;
    const customer = <CustomerRoleTag/>;

    const chooseRole = (role) => {
        switch (role) {
            case roles.SMS :
                return sms;
            case roles.BAM:
                return digicel;
            case roles.CUSTOMER_REP:
                return customer;
            case roles.GK:
                return grace;
            default:
                return null;
        }
    };

    return (
        <ContentWrapper>
            {chooseRole(role)}
        </ContentWrapper>
    );
}

UserRole.propTypes = {};
UserRole.defaultProps = {};

export default UserRole;
